// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"827dc233","112":"86b37475","321":"045a720c","488":"a8b80d5c","672":"4c7d44b8","782":"3ff3581b","928":"fa1e9cf6"}[chunkId] + ".chunk.js";
};